import { NetworkConstants } from './types';

const initialState = {
  lastRequest: {
    category: undefined,
    api_location: undefined,
  },
};

export function networkReducer(state = initialState, action) {
  switch (action.type) {
    case NetworkConstants.SetLastRequest:
      return {
        ...state,
        lastRequest: action.payload,
      };
    case NetworkConstants.ClearLastRequest:
      return {
        ...state,
        lastRequest: undefined,
      };
    default:
      return state;
  }
}
